<template>
	<nk-page commercialAccess="Salary" class="" :policyClaims="``" tabindex="101" startup>
		<template #badges>
			<nk-badge system="salary">
				<nk-badge-item type="system" modelValue="salary"></nk-badge-item>
				<nk-badge-item type="system" modelValue="salary" :title="$t('salary.variable.salary-item-variable')"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="settings.mode === FORM_MODES.READONLY ? FORM_MODES.READONLY : (isEmpty(localData.id) ? 'new' : 'edit')"></nk-badge-item>

			</nk-badge>
			<div class="nk-card form-container m-2 d-flex flex-column" ref="parent">
				<div class="row mb-3">
					<div class="col-sm-12 col-md-12 col-lg-12">
						<nk-col-form-group :label="$t('salary.variable.title') + ':'" :labelSizes="{ sm: 12, md: 2 }" :dataSizes="{ sm: 12, md: 10 }" :labelAligns="{ sm: 'right', md: 'left', lg: 'left' }">
							<nk-input class="" v-model="localData.title" :options="localOptions.title" :tabindex="106"></nk-input>
						</nk-col-form-group>
					</div>
					<div class="col-sm-12 col-md-12 col-lg-12">
						<nk-col-form-group :label="$t('salary.variable.value') + ':'" :labelSizes="{ sm: 12, md: 2 }" :dataSizes="{ sm: 12, md: 10 }" :labelAligns="{ sm: 'right', md: 'left', lg: 'left' }">
							<nk-input class="" v-model="localData.value" :options="localOptions.value" :tabindex="107"></nk-input>
						</nk-col-form-group>
					</div>
				</div>
			</div>
		</template>
	</nk-page>
</template>

<script lang="ts">
	import { defineComponent, PropType } from 'vue'
	import merge from 'lodash/merge'
	import { SalaryVariable } from '@/classes/salary/salary-variable'
	import $sc from '@/plugins/shortcut.collection'
	import validators, { Checker, isEmpty, VCustom } from '@/statics/validators'
	import Endpoints from '@nikan/endpoints'
	import { post } from '@/plugins/nikan-api'
	import { IResponse } from '@/interfaces/base'
	import { TYPE } from 'vue-toastification'
	import { clone } from 'lodash'

	export default defineComponent({
		name: "modify-variable",
		modal: {
			size: 'sm',
			stateUID: 'modify-variable',
			helpTag: 'ModifyVariable'
		},
		props: {
			data: Object,
			options: Object
		},
		data() {
			return {
				localData: new SalaryVariable() as SalaryVariable,
				localOptions: {
					title: {
						mode: 'string'
					},
					value: {
						mode: 'number'
					}
				},
				topButtons: {
					saveButton: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						isPrimary: false,
						disabled: false,
						icon: 'save',
						handle: () => {
							this.save()
						},
						policyClaims: ['Salary_SalaryItemVariable_Edit', 'Salary_SalaryItemVariable_Add'],
						selfButton: true,
						// items: [],
					},
					// addButton: {
					// 	title: this.$t('new'),
					// 	shortcut: $sc.find('new'),
					// 	icon: 'plus',
					// 	isPrimary: false,
					// 	visible: true,
					// 	handle: () => {
					// 		this.clearForm()
					// 	},
					// 	// policyClaims: 'Salary_ItemVariable_Add',
					// },
				},
				settings: {} as any,
				validators: {
					localData: {
						title: validators('required'),
						value: validators('required'),
					},
				},
			}
		},
		created() {
			merge(this.settings, this.options)
			if (this.data) this.localData = clone(this.data as SalaryVariable)
		},
		mounted() {
			// if (!isEmpty(this.localData.id)) this.topButtons.addButton.visible = false
			this.prepareWindow(this.$t(`salary.variable.${isEmpty(this.localData.id) ? 'insert-variable' : 'edit-variable'}`), Object.values(this.topButtons))
		},
		methods: {
			isEmpty,
			clearForm() {
				this.localData = new SalaryVariable()
			},
			validateInputs() {
				let checker = new Checker((name: string) => this.$t(`salary.validation.messages.salary-item-variable-modify.${name}`))
				let errors = checker.test(this.localData, this.validators.localData)
				this.validationToast(errors)
				return errors.length === 0
			},
			save() {
				return new Promise((resolve, reject) => {
					let url
					if (isEmpty(this.localData.id)) {
						url = Endpoints.getUrl('salaryItemVariable.create')
					} else {
						url = Endpoints.getUrl('salaryItemVariable.update')
					}
					if (this.validateInputs()) {
						let wait = this.$wait(this.grandParent)
						post(url, { salaryItemVariable: this.localData })
							.then((response: IResponse<any>) => {
								wait.end()
								this.$toast(this.$t('salary.variable.m.create-successful', { name: this.localData.title }), { type: TYPE.SUCCESS })
								this.resolve(response.data)
							})
							.catch(() => {
								wait.end()
							})
					}
				})
			},
		}
	})
</script>

<style scoped></style>